/* eslint-disable no-new */
import React, { Component } from 'react'
import { graphql, StaticQuery } from 'gatsby'
import classNames from 'classnames'
import MenuItem from './MenuItem'
import Sprite from '~components/Sprite'
import Link from '~components/Link'
import * as styles from '../../styles/layout/header.module.scss'
import * as buttonStyles from '~styles/components/button.module.scss'
import * as navStyles from '../../styles/layout/nav.module.scss'

export default class Header extends Component {
  constructor (props) {
    super(props)

    this.headerRef = React.createRef()

    this.state = {
      activeItem: null,
      open: false
    }
  }

  toggleMenu (e) {
    this.setState(() => {
      return { open: !this.state.open }
    })

    const toggleClass = this.state.open ? 'add' : 'remove'
    document.body.classList[toggleClass]('nav-open')
  }

  onItemMouseEnter (id) {
    this.setState({ activeItem: id })
  }

  onItemMouseLeave () {
    this.setState({ activeItem: null })
  }

  render () {
    const _render = ({ contentfulMenu }) => {
      const items = contentfulMenu.items
        .filter((item) => item.contentfulparent === null)
        .map((item) => {
          item.children = contentfulMenu.items.filter(
            (child) =>
              child.contentfulparent && child.contentfulparent.id === item.id
          )

          return item
        })

      return (
        <header className={styles.header} ref={this.headerRef}>
          <div className={classNames('grid-container', styles.inner)}>
            <div className={classNames(styles.links)}>
              <button
                type="button"
                className={styles.toggle}
                onClick={this.toggleMenu.bind(this)}
                onFocus={this.toggleMenu.bind(this)}
                aria-label="Toggle menu"
              >
                <span className={styles.lines}></span>
              </button>

              <Link
                href="/"
                className={classNames(styles.icon)}
                aria-label="London City Airport"
              >
                <Sprite name="circleHeart" />
              </Link>
            </div>

            <Link
              href="/"
              className={classNames(styles.logo, 'show-for-large')}
              aria-label="London City Airport"
            >
              <Sprite name="logo" />
            </Link>

            <nav className={classNames(navStyles.nav)}>
              <ul className={navStyles.menu}>
                {items.map(item => (
                  <MenuItem
                    key={item.id}
                    item={item}
                    active={this.state.activeItem === item.id}
                    onMouseEnter={this.onItemMouseEnter.bind(this, item.id)}
                    onMouseLeave={this.onItemMouseLeave.bind(this)}
                    onClick={() => this.toggleMenu()}
                  />
                ))}
              </ul>
            </nav>

            <Link
              href="/about/get-in-touch"
              className={classNames(styles.button, buttonStyles.button)}
              aria-label="Get in touch"
              track={{
                category: 'intent-ms-Contact',
                action: 'Click',
                label: 'Get in touch'
              }}
            >
              Get in touch
              <span className={classNames(buttonStyles.icon, 'icon')}>
                <Sprite name="arrow" fill={true} />
              </span>
            </Link>
          </div>
        </header>
      )
    }

    return <StaticQuery query={query} render={_render} />
  }
}

export const query = graphql`
  query {
    contentfulMenu(name: { eq: "main-menu" }) {
      items {
        id
        title
        page {
          slug
        }
        contentfulparent {
          id
        }
      }
    }
  }
`
